var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './NetworksControlPage.scss';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Avatar, Button, Divider, Form, Input, Modal, Popconfirm, Select, Space, Spin, Table, Tag, Upload, message, } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, UnorderedListOutlined, } from '@ant-design/icons';
import { AiFillCheckCircle, AiOutlineCheckCircle } from 'react-icons/ai';
import { useGetAllNetworksQuery, useCreateNetworkMutation, useUpdateNetworkMutation, useDeleteNetworkMutation, useGetNetworkRestaurantsQuery, useUploadNetworkPhotoMutation, } from '@/services/restNetworkApi';
import Loader from '@/components/Loader/Loader';
import { ADMIN_PATHS } from '@/routes/paths/adminPaths';
import { useGetRestaurantsQuery, useGetRestaurantsWithSearchQuery, useAssignRestaurantToNetworkMutation, } from '@/services/restaurantsApi';
import { useGetCitiesQuery } from '@/services/citiesApi';
var Search = Input.Search;
var Option = Select.Option;
/** Как на странице заведений — фильтр по полю type */
var RESTAURANT_CATEGORIES = [
    'Караоке/клубы',
    'Кафе/бары/рестораны',
    'Lounge',
    'Фитнес/спорт/активный отдых',
    'Кофейни',
    'Другое',
];
function matchesRestaurantSearch(rest, query) {
    var _a;
    var n = query.trim().toLowerCase();
    if (!n)
        return true;
    var parts = [
        rest === null || rest === void 0 ? void 0 : rest.name,
        rest === null || rest === void 0 ? void 0 : rest.address,
        rest === null || rest === void 0 ? void 0 : rest.type,
        rest === null || rest === void 0 ? void 0 : rest.phone,
        (_a = rest === null || rest === void 0 ? void 0 : rest.city) === null || _a === void 0 ? void 0 : _a.name,
    ]
        .filter(function (x) { return x != null && String(x).length > 0; })
        .map(function (x) { return String(x).toLowerCase(); });
    return parts.some(function (p) { return p.includes(n); });
}
/** Уже в сети — в начале списка, далее по названию. */
function sortRestaurantsInNetworkFirst(list, selectedIds) {
    var selected = new Set(selectedIds);
    return __spreadArray([], list, true).sort(function (a, b) {
        var aIn = selected.has(a.id) ? 0 : 1;
        var bIn = selected.has(b.id) ? 0 : 1;
        if (aIn !== bIn)
            return aIn - bIn;
        return (a.name || '').localeCompare(b.name || '', 'ru');
    });
}
var NetworksControlPage = function () {
    var _a = useGetAllNetworksQuery(undefined, {
        refetchOnMountOrArgChange: true,
    }), networks = _a.data, isLoading = _a.isLoading, isError = _a.isError, refetch = _a.refetch;
    var _b = useCreateNetworkMutation(), createNetwork = _b[0], creating = _b[1].isLoading;
    var _c = useUpdateNetworkMutation(), updateNetwork = _c[0], updating = _c[1].isLoading;
    var _d = useUploadNetworkPhotoMutation(), uploadNetworkPhoto = _d[0], uploadingPhoto = _d[1].isLoading;
    var _e = useDeleteNetworkMutation(), deleteNetwork = _e[0], deleting = _e[1].isLoading;
    var _f = useState(''), search = _f[0], setSearch = _f[1];
    var _g = useState(false), modalOpen = _g[0], setModalOpen = _g[1];
    var _h = useState(null), editing = _h[0], setEditing = _h[1];
    /** Выбранное фото до сохранения новой сети (загрузка на сервер после create) */
    var _j = useState(null), createDraftPhoto = _j[0], setCreateDraftPhoto = _j[1];
    var form = Form.useForm()[0];
    var createDraftPreview = useMemo(function () { return (createDraftPhoto ? URL.createObjectURL(createDraftPhoto) : null); }, [createDraftPhoto]);
    useEffect(function () {
        return function () {
            if (createDraftPreview)
                URL.revokeObjectURL(createDraftPreview);
        };
    }, [createDraftPreview]);
    var _k = useState(null), manageNetworkId = _k[0], setManageNetworkId = _k[1];
    var _l = useState(''), manageNetworkName = _l[0], setManageNetworkName = _l[1];
    var _m = useState(), modalCityId = _m[0], setModalCityId = _m[1];
    var _o = useState(''), modalCategoryType = _o[0], setModalCategoryType = _o[1];
    var _p = useState(''), networkGridSearch = _p[0], setNetworkGridSearch = _p[1];
    var _q = useState(''), debouncedNetworkGridSearch = _q[0], setDebouncedNetworkGridSearch = _q[1];
    var _r = useState([]), selectedInNetworkIds = _r[0], setSelectedInNetworkIds = _r[1];
    var _s = useState(false), selectionTouched = _s[0], setSelectionTouched = _s[1];
    var _t = useState(false), savingNetworkMembers = _t[0], setSavingNetworkMembers = _t[1];
    var initialInNetworkIdsRef = useRef(new Set());
    var cities = useGetCitiesQuery().data;
    var _u = useGetNetworkRestaurantsQuery({ id: manageNetworkId }, { skip: manageNetworkId == null }), restaurantsInNetwork = _u.data, restaurantsLoading = _u.isFetching;
    var _v = useGetRestaurantsQuery(__assign(__assign({}, (modalCityId != null ? { cityId: modalCityId } : {})), (modalCategoryType ? { type: modalCategoryType } : {})), { skip: manageNetworkId == null }), modalRestaurants = _v.data, loadingModalRestaurants = _v.isLoading;
    useEffect(function () {
        var t = window.setTimeout(function () { return setDebouncedNetworkGridSearch(networkGridSearch.trim()); }, 320);
        return function () { return window.clearTimeout(t); };
    }, [networkGridSearch]);
    useEffect(function () {
        if (manageNetworkId == null) {
            setNetworkGridSearch('');
            setDebouncedNetworkGridSearch('');
        }
    }, [manageNetworkId]);
    useEffect(function () {
        setNetworkGridSearch('');
        setDebouncedNetworkGridSearch('');
    }, [modalCityId, modalCategoryType]);
    var networkGridSearchActive = debouncedNetworkGridSearch.length > 0;
    var _w = useGetRestaurantsWithSearchQuery(__assign(__assign({ page: 1, limit: 500, search: debouncedNetworkGridSearch }, (modalCityId != null ? { cityId: modalCityId } : {})), (modalCategoryType ? { type: modalCategoryType } : {})), { skip: manageNetworkId == null || !networkGridSearchActive }), networkGridSearchPayload = _w.data, loadingNetworkGridSearch = _w.isFetching;
    var networkGridDisplayRestaurants = useMemo(function () {
        var _a;
        var full = modalRestaurants !== null && modalRestaurants !== void 0 ? modalRestaurants : [];
        var q = debouncedNetworkGridSearch;
        if (!q) {
            return sortRestaurantsInNetworkFirst(full, selectedInNetworkIds);
        }
        var fromApi = (_a = networkGridSearchPayload === null || networkGridSearchPayload === void 0 ? void 0 : networkGridSearchPayload.data) !== null && _a !== void 0 ? _a : [];
        var apiIds = new Set(fromApi.map(function (r) { return r.id; }));
        var selectedIds = new Set(selectedInNetworkIds);
        var selectedFirst = full.filter(function (r) { return selectedIds.has(r.id) && !apiIds.has(r.id); });
        var localHits = full.filter(function (r) { return matchesRestaurantSearch(r, q) && !apiIds.has(r.id); });
        var seen = new Set();
        var out = [];
        for (var _i = 0, _b = __spreadArray(__spreadArray(__spreadArray([], selectedFirst, true), localHits, true), fromApi, true); _i < _b.length; _i++) {
            var r = _b[_i];
            if (!seen.has(r.id)) {
                seen.add(r.id);
                out.push(r);
            }
        }
        return sortRestaurantsInNetworkFirst(out, selectedInNetworkIds);
    }, [
        networkGridSearchPayload,
        modalRestaurants,
        selectedInNetworkIds,
        debouncedNetworkGridSearch,
    ]);
    useEffect(function () {
        if (manageNetworkId == null) {
            setSelectionTouched(false);
            setSelectedInNetworkIds([]);
            initialInNetworkIdsRef.current = new Set();
            return;
        }
        if (selectionTouched)
            return;
        if (restaurantsInNetwork && !restaurantsLoading) {
            var ids = restaurantsInNetwork.map(function (r) { return r.id; });
            setSelectedInNetworkIds(ids);
            initialInNetworkIdsRef.current = new Set(ids);
        }
    }, [manageNetworkId, restaurantsInNetwork, restaurantsLoading, selectionTouched]);
    var assignRestaurantToNetwork = useAssignRestaurantToNetworkMutation()[0];
    var filtered = useMemo(function () {
        if (!networks)
            return [];
        var q = search.trim().toLowerCase();
        if (!q)
            return networks;
        return networks.filter(function (n) {
            return n.name.toLowerCase().includes(q) ||
                (n.city && String(n.city).toLowerCase().includes(q));
        });
    }, [networks, search]);
    var establishmentCount = function (row) { var _a; return (_a = row.restaurantCount) !== null && _a !== void 0 ? _a : 0; };
    var openCreate = function () {
        setEditing(null);
        setCreateDraftPhoto(null);
        form.resetFields();
        setModalOpen(true);
    };
    var openEdit = function (row) {
        setCreateDraftPhoto(null);
        setEditing(row);
        form.setFieldsValue({ name: row.name, city: row.city || undefined });
        setModalOpen(true);
    };
    var openManageNetwork = function (row) {
        setManageNetworkName(row.name);
        setModalCityId(undefined);
        setModalCategoryType('');
        setNetworkGridSearch('');
        setDebouncedNetworkGridSearch('');
        setSelectionTouched(false);
        setManageNetworkId(row.id);
    };
    var closeManageNetwork = function () {
        setManageNetworkId(null);
        setManageNetworkName('');
        setModalCityId(undefined);
        setModalCategoryType('');
        setNetworkGridSearch('');
        setDebouncedNetworkGridSearch('');
        setSelectedInNetworkIds([]);
        setSelectionTouched(false);
    };
    var toggleNetworkRestaurant = function (restaurantId) {
        setSelectionTouched(true);
        setSelectedInNetworkIds(function (prev) {
            return prev.includes(restaurantId) ? prev.filter(function (id) { return id !== restaurantId; }) : __spreadArray(__spreadArray([], prev, true), [restaurantId], false);
        });
    };
    var handleSaveNetworkMembers = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var initial, selected, toAdd, toRemove, _i, toAdd_1, id, _a, toRemove_1, id, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (manageNetworkId == null)
                            return [2 /*return*/];
                        initial = initialInNetworkIdsRef.current;
                        selected = new Set(selectedInNetworkIds);
                        toAdd = selectedInNetworkIds.filter(function (id) { return !initial.has(id); });
                        toRemove = __spreadArray([], initial, true).filter(function (id) { return !selected.has(id); });
                        if (toAdd.length === 0 && toRemove.length === 0) {
                            message.info('Изменений нет');
                            closeManageNetwork();
                            return [2 /*return*/];
                        }
                        setSavingNetworkMembers(true);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 10, 11, 12]);
                        _i = 0, toAdd_1 = toAdd;
                        _c.label = 2;
                    case 2:
                        if (!(_i < toAdd_1.length))
                            return [3 /*break*/, 5];
                        id = toAdd_1[_i];
                        return [4 /*yield*/, assignRestaurantToNetwork({
                                restaurantId: id,
                                networkId: manageNetworkId,
                            }).unwrap()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        _a = 0, toRemove_1 = toRemove;
                        _c.label = 6;
                    case 6:
                        if (!(_a < toRemove_1.length))
                            return [3 /*break*/, 9];
                        id = toRemove_1[_a];
                        return [4 /*yield*/, assignRestaurantToNetwork({ restaurantId: id, networkId: null }).unwrap()];
                    case 7:
                        _c.sent();
                        _c.label = 8;
                    case 8:
                        _a++;
                        return [3 /*break*/, 6];
                    case 9:
                        message.success('Состав сети обновлён');
                        closeManageNetwork();
                        refetch();
                        return [3 /*break*/, 12];
                    case 10:
                        _b = _c.sent();
                        message.error('Не удалось сохранить изменения');
                        return [3 /*break*/, 12];
                    case 11:
                        setSavingNetworkMembers(false);
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    var handleModalOk = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var v, _a, cityVal, created, _b, e_1, err;
            var _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, form.validateFields()];
                    case 1:
                        v = _e.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _e.sent();
                        return [2 /*return*/];
                    case 3:
                        cityVal = ((_c = v.city) === null || _c === void 0 ? void 0 : _c.trim()) ? v.city.trim() : null;
                        _e.label = 4;
                    case 4:
                        _e.trys.push([4, 15, , 16]);
                        if (!editing)
                            return [3 /*break*/, 6];
                        return [4 /*yield*/, updateNetwork({
                                id: editing.id,
                                body: { name: v.name.trim(), city: cityVal },
                            }).unwrap()];
                    case 5:
                        _e.sent();
                        message.success('Сеть обновлена');
                        return [3 /*break*/, 14];
                    case 6: return [4 /*yield*/, createNetwork({ name: v.name.trim(), city: cityVal }).unwrap()];
                    case 7:
                        created = _e.sent();
                        if (!createDraftPhoto)
                            return [3 /*break*/, 12];
                        _e.label = 8;
                    case 8:
                        _e.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, uploadNetworkPhoto({ id: created.id, file: createDraftPhoto }).unwrap()];
                    case 9:
                        _e.sent();
                        message.success('Сеть создана, фото добавлено');
                        return [3 /*break*/, 11];
                    case 10:
                        _b = _e.sent();
                        message.warning('Сеть создана, но фото не удалось загрузить — добавьте его при редактировании');
                        return [3 /*break*/, 11];
                    case 11: return [3 /*break*/, 13];
                    case 12:
                        message.success('Сеть создана');
                        _e.label = 13;
                    case 13:
                        setCreateDraftPhoto(null);
                        _e.label = 14;
                    case 14:
                        setModalOpen(false);
                        setEditing(null);
                        form.resetFields();
                        refetch();
                        return [3 /*break*/, 16];
                    case 15:
                        e_1 = _e.sent();
                        err = e_1;
                        message.error(((_d = err === null || err === void 0 ? void 0 : err.data) === null || _d === void 0 ? void 0 : _d.message) || 'Не удалось сохранить');
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    var handleNetworkPhotoUpload = function (file) {
        return __awaiter(void 0, void 0, void 0, function () {
            var net_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!editing)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, uploadNetworkPhoto({ id: editing.id, file: file }).unwrap()];
                    case 2:
                        net_1 = _b.sent();
                        setEditing(function (prev) { return (prev && prev.id === net_1.id ? __assign(__assign({}, prev), { photoUrl: net_1.photoUrl }) : prev); });
                        message.success('Фото обновлено');
                        refetch();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message.error('Не удалось загрузить фото');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var handleRemoveNetworkPhoto = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!editing)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, updateNetwork({ id: editing.id, body: { photoUrl: null } }).unwrap()];
                    case 2:
                        _b.sent();
                        setEditing(function (prev) { return (prev ? __assign(__assign({}, prev), { photoUrl: null }) : prev); });
                        message.success('Фото удалено');
                        refetch();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        message.error('Не удалось удалить фото');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var handleDelete = function (row) {
        return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deleteNetwork(row.id).unwrap()];
                    case 1:
                        _b.sent();
                        message.success('Сеть удалена');
                        refetch();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        message.error('Не удалось удалить сеть');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var networkGridExtra = 'Нажмите на карточку, чтобы добавить заведение в сеть или убрать из неё. Изменения применяются по кнопке «Сохранить». Поиск — по названию, адресу и городу (как в рекомендациях).';
    var networkGridSearchInput = (_jsx(Search, { placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E, \u0430\u0434\u0440\u0435\u0441\u0443, \u0433\u043E\u0440\u043E\u0434\u0443\u2026", allowClear: true, value: networkGridSearch, onChange: function (e) { return setNetworkGridSearch(e.target.value); }, style: { marginBottom: 12 }, loading: networkGridSearchActive && loadingNetworkGridSearch }));
    var columns = [
        {
            title: 'Фото',
            key: 'photo',
            width: 72,
            render: function (_, row) {
                return row.photoUrl ? (_jsx(Avatar, { shape: "square", size: 48, src: row.photoUrl, alt: "" })) : (_jsx("span", __assign({ style: { color: '#bfbfbf' } }, { children: "\u2014" })));
            },
        },
        { title: 'Название', dataIndex: 'name', key: 'name' },
        {
            title: 'Город (справочно)',
            dataIndex: 'city',
            key: 'city',
            render: function (c) { return c || '—'; },
        },
        {
            title: 'Заведений',
            key: 'cnt',
            width: 120,
            render: function (_, row) { return establishmentCount(row); },
        },
        {
            title: 'Действия',
            key: 'actions',
            width: 280,
            render: function (_, row) {
                return (_jsxs(Space, __assign({ wrap: true }, { children: [_jsx(Button, __assign({ type: "link", icon: _jsx(UnorderedListOutlined, {}), onClick: function () { return openManageNetwork(row); } }, { children: "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F" })), _jsx(Button, __assign({ type: "link", icon: _jsx(EditOutlined, {}), onClick: function () { return openEdit(row); } }, { children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C" })), _jsx(Popconfirm, __assign({ title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0435\u0442\u044C?", description: establishmentCount(row) > 0
                                ? "\u0412 \u0441\u0435\u0442\u0438 ".concat(establishmentCount(row), " \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439. \u0423 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043F\u043E\u043B\u0435 \u00AB\u0441\u0435\u0442\u044C\u00BB \u0431\u0443\u0434\u0435\u0442 \u043E\u0447\u0438\u0449\u0435\u043D\u043E.")
                                : undefined, onConfirm: function () { return handleDelete(row); }, okText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", okButtonProps: { loading: deleting } }, { children: _jsx(Button, __assign({ type: "link", danger: true, icon: _jsx(DeleteOutlined, {}) }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })) }))] })));
            },
        },
    ];
    if (isLoading) {
        return (_jsx("div", __assign({ className: "NetworksControlPage" }, { children: _jsx("div", __assign({ className: "NetworksControlPage__loader" }, { children: _jsx(Loader, {}) })) })));
    }
    if (isError) {
        return (_jsxs("div", __assign({ className: "NetworksControlPage" }, { children: [_jsx("div", __assign({ className: "NetworksControlPage__titleBlock" }, { children: _jsx("h1", __assign({ className: "NetworksControlPage__pageTitle" }, { children: "\u0421\u0435\u0442\u0438 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439" })) })), _jsx("p", __assign({ style: { padding: 40 } }, { children: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u043F\u0438\u0441\u043A\u0430 \u0441\u0435\u0442\u0435\u0439" }))] })));
    }
    return (_jsxs("div", __assign({ className: "NetworksControlPage" }, { children: [_jsxs("div", __assign({ className: "NetworksControlPage__titleBlock" }, { children: [_jsx("h1", __assign({ className: "NetworksControlPage__pageTitle" }, { children: "\u0421\u0435\u0442\u0438 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439" })), _jsxs("div", __assign({ className: "NetworksControlPage__toolbar" }, { children: [_jsx(Button, __assign({ type: "primary", icon: _jsx(PlusOutlined, {}), onClick: openCreate }, { children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0435\u0442\u044C" })), _jsx(Input, { allowClear: true, className: "NetworksControlPage__searchInput", placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E \u0438\u043B\u0438 \u0433\u043E\u0440\u043E\u0434\u0443", prefix: _jsx(SearchOutlined, { className: "NetworksControlPage__searchIcon", "aria-hidden": true }), onChange: function (e) { return setSearch(e.target.value); } })] }))] })), _jsx("div", __assign({ className: "NetworksControlPage__tableWrap" }, { children: _jsx(Table, { rowKey: "id", columns: columns, dataSource: filtered, pagination: { pageSize: 15, showSizeChanger: false } }) })), _jsx(Modal, __assign({ title: editing ? 'Редактирование сети' : 'Новая сеть', open: modalOpen, onOk: handleModalOk, onCancel: function () {
                    setModalOpen(false);
                    setEditing(null);
                    setCreateDraftPhoto(null);
                    form.resetFields();
                }, confirmLoading: creating || updating || uploadingPhoto, okText: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", destroyOnClose: true }, { children: _jsxs(Form, __assign({ form: form, layout: "vertical", style: { marginTop: 16 } }, { children: [_jsx(Form.Item, __assign({ name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", rules: [{ required: true, message: 'Укажите название' }] }, { children: _jsx(Input, { placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0435\u0442\u0438" }) })), _jsx(Form.Item, __assign({ name: "city", label: "\u0413\u043E\u0440\u043E\u0434 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)" }, { children: _jsx(Input, { placeholder: "\u0422\u0435\u043A\u0441\u0442 \u0434\u043B\u044F \u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u0432 \u0441\u043F\u0438\u0441\u043A\u0430\u0445" }) })), _jsx(Form.Item, __assign({ label: "\u0424\u043E\u0442\u043E \u0441\u0435\u0442\u0438", extra: editing
                                ? undefined
                                : 'Фото будет загружено на сервер после сохранения новой сети.' }, { children: _jsxs(Space, __assign({ align: "start", size: 16, wrap: true }, { children: [editing ? (editing.photoUrl ? (_jsx("img", { src: editing.photoUrl, alt: "", style: {
                                            width: 120,
                                            height: 120,
                                            objectFit: 'cover',
                                            borderRadius: 8,
                                            border: '1px solid #d9d9d9',
                                        } })) : (_jsx("div", __assign({ style: {
                                            width: 120,
                                            height: 120,
                                            borderRadius: 8,
                                            border: '1px dashed #d9d9d9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#bfbfbf',
                                            fontSize: 13,
                                        } }, { children: "\u041D\u0435\u0442 \u0444\u043E\u0442\u043E" })))) : createDraftPreview ? (_jsx("img", { src: createDraftPreview, alt: "", style: {
                                            width: 120,
                                            height: 120,
                                            objectFit: 'cover',
                                            borderRadius: 8,
                                            border: '1px solid #d9d9d9',
                                        } })) : (_jsx("div", __assign({ style: {
                                            width: 120,
                                            height: 120,
                                            borderRadius: 8,
                                            border: '1px dashed #d9d9d9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#bfbfbf',
                                            fontSize: 13,
                                        } }, { children: "\u041D\u0435\u0442 \u0444\u043E\u0442\u043E" }))), _jsxs(Space, __assign({ direction: "vertical", align: "start" }, { children: [_jsx(Upload, __assign({ accept: "image/*", showUploadList: false, disabled: uploadingPhoto || creating, beforeUpload: function (file) {
                                                    if (editing) {
                                                        void handleNetworkPhotoUpload(file);
                                                    }
                                                    else {
                                                        setCreateDraftPhoto(file);
                                                    }
                                                    return false;
                                                } }, { children: _jsx(Button, __assign({ loading: uploadingPhoto && Boolean(editing) }, { children: editing ? 'Загрузить фото' : 'Выбрать фото' })) })), editing && editing.photoUrl ? (_jsx(Button, __assign({ type: "link", danger: true, onClick: function () { return void handleRemoveNetworkPhoto(); } }, { children: "\u0423\u0431\u0440\u0430\u0442\u044C \u0444\u043E\u0442\u043E" }))) : null, !editing && createDraftPhoto ? (_jsx(Button, __assign({ type: "link", danger: true, onClick: function () { return setCreateDraftPhoto(null); } }, { children: "\u0423\u0431\u0440\u0430\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0444\u043E\u0442\u043E" }))) : null] }))] })) }))] })) })), _jsx(Modal, __assign({ title: "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0441\u0435\u0442\u0438: ".concat(manageNetworkName), open: manageNetworkId != null, onCancel: closeManageNetwork, onOk: handleSaveNetworkMembers, okText: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", width: 800, confirmLoading: savingNetworkMembers, destroyOnClose: true }, { children: _jsxs(Form, __assign({ layout: "vertical" }, { children: [_jsx("div", __assign({ style: { marginBottom: 12, color: '#666', fontSize: 13 } }, { children: "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0438\u0437 \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u0435\u0442\u0438 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0441\u044E\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043D\u043E \u0432 \u044D\u0442\u0443 \u0441\u0435\u0442\u044C. \u0421\u043D\u044F\u0442\u0438\u0435 \u043E\u0442\u043C\u0435\u0442\u043A\u0438 \u0443\u0431\u0438\u0440\u0430\u0435\u0442 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u0435\u0442\u0438 (\u0441\u0430\u043C\u043E \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043D\u0435 \u0443\u0434\u0430\u043B\u044F\u0435\u0442\u0441\u044F)." })), _jsxs("div", __assign({ style: { display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 8 } }, { children: [_jsx(Form.Item, __assign({ label: "\u0413\u043E\u0440\u043E\u0434 \u0434\u043B\u044F \u0441\u043F\u0438\u0441\u043A\u0430 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439", style: { flex: '1 1 220px', marginBottom: 0 } }, { children: _jsx(Select, __assign({ allowClear: true, placeholder: "\u0412\u0441\u0435 \u0433\u043E\u0440\u043E\u0434\u0430", value: modalCityId, onChange: function (v) { return setModalCityId(v); }, style: { width: '100%' } }, { children: cities === null || cities === void 0 ? void 0 : cities.map(function (city) { return (_jsx(Option, __assign({ value: city.id }, { children: city.name }), city.id)); }) })) })), _jsx(Form.Item, __assign({ label: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F", style: { flex: '1 1 220px', marginBottom: 0 } }, { children: _jsx(Select, __assign({ allowClear: true, placeholder: "\u0412\u0441\u0435 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438", value: modalCategoryType || undefined, onChange: function (v) { return setModalCategoryType(v !== null && v !== void 0 ? v : ''); }, style: { width: '100%' } }, { children: RESTAURANT_CATEGORIES.map(function (cat) { return (_jsx(Option, __assign({ value: cat }, { children: cat }), cat)); }) })) }))] })), _jsx(Divider, { children: "\u0421\u043E\u0441\u0442\u0430\u0432 \u0441\u0435\u0442\u0438" }), _jsxs(Form.Item, __assign({ label: "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0432 \u0441\u0435\u0442\u0438", extra: networkGridExtra }, { children: [networkGridSearchInput, _jsx(Spin, __assign({ spinning: Boolean(networkGridSearchActive && loadingNetworkGridSearch) ||
                                        (loadingModalRestaurants && !networkGridSearchActive) }, { children: _jsx("div", __assign({ style: {
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                                            gap: 8,
                                            maxHeight: 360,
                                            overflowY: 'auto',
                                            padding: 8,
                                            border: '1px solid #d9d9d9',
                                            borderRadius: 6,
                                            minHeight: networkGridDisplayRestaurants.length === 0 ? 80 : undefined,
                                        } }, { children: networkGridDisplayRestaurants.length === 0 &&
                                            !(networkGridSearchActive && loadingNetworkGridSearch) &&
                                            !loadingModalRestaurants ? (_jsx("div", __assign({ style: { gridColumn: '1 / -1', padding: 16, textAlign: 'center', color: '#999' } }, { children: networkGridSearchActive ? 'Ничего не найдено' : 'Нет заведений для отображения' }))) : (networkGridDisplayRestaurants.map(function (rest) {
                                            var _a, _b, _c, _d, _e;
                                            var inNetwork = selectedInNetworkIds.includes(rest.id);
                                            var otherNetId = (_a = rest.networkId) !== null && _a !== void 0 ? _a : (_b = rest.network) === null || _b === void 0 ? void 0 : _b.id;
                                            var otherNetName = (_c = rest.network) === null || _c === void 0 ? void 0 : _c.name;
                                            var inOtherNetwork = manageNetworkId != null &&
                                                otherNetId != null &&
                                                otherNetId !== manageNetworkId;
                                            return (_jsxs("div", __assign({ style: {
                                                    padding: 12,
                                                    border: '1px solid',
                                                    borderColor: inNetwork ? '#52c41a' : '#d9d9d9',
                                                    borderRadius: 6,
                                                    backgroundColor: inNetwork ? '#f6ffed' : 'white',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                }, onClick: function () { return toggleNetworkRestaurant(rest.id); } }, { children: [_jsxs("div", __assign({ style: {
                                                            display: 'flex',
                                                            alignItems: 'flex-start',
                                                            justifyContent: 'space-between',
                                                            gap: 8,
                                                        } }, { children: [_jsx("div", __assign({ style: { fontWeight: 'bold', flex: 1, minWidth: 0 } }, { children: rest.name })), inNetwork ? (_jsx(AiFillCheckCircle, { style: { color: '#52c41a', fontSize: 20, flexShrink: 0 } })) : (_jsx(AiOutlineCheckCircle, { style: { color: '#d9d9d9', fontSize: 20, flexShrink: 0 } }))] })), _jsxs("div", __assign({ style: { fontSize: 12, color: '#666', marginTop: 4 } }, { children: [rest.type || '—', rest.inAction === true && (_jsx(Tag, __assign({ className: "NetworksControlPage__egoRecommendTag", style: { marginLeft: 6 } }, { children: "\u042D\u0433\u043E \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442" })))] })), (rest.address || ((_d = rest.city) === null || _d === void 0 ? void 0 : _d.name)) && (_jsx("div", __assign({ style: { fontSize: 11, color: '#888', marginTop: 4 } }, { children: [rest.address, (_e = rest.city) === null || _e === void 0 ? void 0 : _e.name].filter(Boolean).join(' · ') }))), inNetwork && (_jsx(Tag, __assign({ color: "success", style: { marginTop: 6, fontSize: 10 } }, { children: "\u0412 \u0441\u0435\u0442\u0438" }))), inOtherNetwork && otherNetName && (_jsxs(Tag, __assign({ color: "warning", style: { marginTop: 4, fontSize: 10 } }, { children: ["\u0421\u0435\u0439\u0447\u0430\u0441: ", otherNetName] }))), _jsx("div", __assign({ style: { marginTop: 8 } }, { children: _jsx(Button, __assign({ type: "link", size: "small", style: { padding: 0, height: 'auto', fontSize: 12 }, href: "".concat(ADMIN_PATHS.ESTABLISHMENTS_UPDATE, "?restId=").concat(rest.id), target: "_blank", rel: "noopener noreferrer", onClick: function (e) { return e.stopPropagation(); } }, { children: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u044F" })) }))] }), rest.id));
                                        })) })) })), _jsxs("div", __assign({ style: { marginTop: 8, fontSize: 12, color: '#52c41a' } }, { children: ["\u0412 \u0441\u0435\u0442\u0438: ", selectedInNetworkIds.length, " \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0439"] }))] }))] })) }))] })));
};
export default NetworksControlPage;
